
/**
 * 뉴스 내용 정보
 */
export type ExploreContentItemContentOneOfFivezeroContent = {
  summary?: string;
};
